import * as React from 'react'

export type FieldAs = 'input' | 'textarea' | 'select'

export interface FieldProps extends React.HTMLAttributes<HTMLElement> {
  label: string
  hint?: string
  error?: string
  as?: FieldAs
  id?: string
  children?: React.ReactNode
}

export const Field = React.forwardRef<HTMLElement, FieldProps>(
  ({ label, hint, error, as = 'input', id, className, children, ...rest }, ref) => {
    const autoId = React.useId()
    const controlId = id ?? autoId
    const hintId = `${controlId}-hint`
    const errorId = `${controlId}-error`
    const describedBy = [error ? errorId : null, hint ? hintId : null].filter(Boolean).join(' ') || undefined
    const Control = as as React.ElementType

    return (
      <div className="z-field">
        <label className="z-field__label" htmlFor={controlId}>
          {label}
        </label>
        <Control
          ref={ref}
          id={controlId}
          className={['z-field__control', className].filter(Boolean).join(' ')}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={describedBy}
          {...rest}
        >
          {children}
        </Control>
        {hint ? (
          <p id={hintId} className="z-field__hint">
            {hint}
          </p>
        ) : null}
        {error ? (
          <p id={errorId} className="z-field__error">
            {error}
          </p>
        ) : null}
      </div>
    )
  },
)
Field.displayName = 'Field'
